import { useTranslation } from 'react-i18next'

import { Message } from 'primereact/message'

import { useDeliveryForecastDespatchAdviceById } from '../../data'
import { validatePackagedQuantity } from './validatePackagedQuantity'

type Props = {
  despatchAdviceId: string
}

export const PackagedQuantityValidation: React.FC<Props> = ({
  despatchAdviceId,
}) => {
  const { t } = useTranslation()
  const { data } = useDeliveryForecastDespatchAdviceById(despatchAdviceId)

  const packagedQuantityValidationState = validatePackagedQuantity(
    data?.Payload,
  )

  if (!data?.Payload || packagedQuantityValidationState?.isValid) return null

  return (
    <Message
      className="w-full justify-content-start"
      severity="warn"
      text={t(
        `deliveryForecastDespatchAdvice.validation.message.${packagedQuantityValidationState?.packagedQuantityState.toString()}`,
      )}
    />
  )
}
